import React from "react";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TextField from "@mui/material/TextField";

const MUITimePicker = ({ currentValue, onChange, disabled = false, label }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <TimePicker
        // label={label || "Select Time"}
        className="w-100"
        value={currentValue || null} // expects Date object or null
        onChange={(newValue) => onChange(newValue)} // pass Date object back
        disabled={disabled}
        renderInput={(params) => (
          <TextField {...params} fullWidth size="small" />
        )}
      />
    </LocalizationProvider>
  );
};

export default MUITimePicker;
